import { AdmAccountingModule } from './admin/adm-accounting/adm-accounting.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { RouterDefaultGuard } from './Shared/routing.guard';
import { AuthGuard } from './auth/auth.guard';

const appRoutes: Routes = [  
  {
    path: '',
    loadChildren: () => import('./login/login.module').then(m => m.loginModule),
  }
];

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forRoot(appRoutes)
  ],
  declarations: [],
  exports: [
    RouterModule
  ],
  providers: [
    RouterDefaultGuard
  ]
})
export class AppRoutingModule { }
